import {
  actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../../../../../../../actions/utilAction';

export { 
  jsonApiHeader, 
  showWarningMessage, 
  showErrorMessage, 
  actionCreator, 
  checkHttpStatus, 
  create_post_data, 
  createSearchUrl, 
  showSuccessMessage 
};

export const POST_LOCATIONS_API = `${API_URL}/api/PatientLocationsReduction/SavePatientLocationsReduction`;
export const GET_LOCATIONS_LIST_API = `${API_URL}/api/PatientLocationsReduction/GetPatientLocationsReduction`;
export const GET_LOCATIONS_DETAIL_API = `${API_URL}/api/PatientLocationsReduction/GetPatientLocationsReductionById`;
export const DELETE_LOCATIONS_API = `${API_URL}/api/PatientLocationsReduction/DeletePatientLocationsReduction`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;

export const locationsActionTypes = {
  get_masterData: createRequestActionTypes('GET_MASTERDATA'),
  save_locations: createRequestActionTypes('SAVE_LOCATIONS'),
  get_locationsList: createRequestActionTypes('GET_LOCATIONSLIST'),
  get_locationsDetail: createRequestActionTypes('GET_LOCATIONSDETAIL'),
  delete_locations: createRequestActionTypes('DELETE_LOCATIONS'),
};

export const MODULE = 'DCMASTER_LOCATIONSREDUCTION';


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Locations/constants/ApiConstants.js